module.exports = __webpack_public_path__ + "img/DZLX.4c52e1f5.png";